import { seeds } from "@/mocks/chigua";
import { catOf, catTone } from "./meta";

const medal = (i: number) =>
  i === 0
    ? "bg-primary-500 text-background-50"
    : i === 1
      ? "bg-secondary-500 text-background-50"
      : i === 2
        ? "bg-accent-500 text-background-50"
        : "bg-background-200 text-foreground-800";

export default function Seeds() {
  const [top, ...rest] = seeds;
  const topCat = catOf(top.category);

  return (
    <section id="seeds" className="scroll-mt-24 bg-accent-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="num-tab mb-3 text-xs tracking-[0.3em] text-accent-700">SEEDS · 种子选手</p>
            <h2 className="font-heading text-3xl font-bold tracking-wide text-foreground-950 md:text-4xl">
              种子选手<span className="text-accent-700">坐镇</span>，黑马随时突围
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              种子选手综合热度值、话题持续时长与全网讨论深度初筛产生；真正的好戏往往在后半场——后劲十足的“黑马”正虎视眈眈。
            </p>
          </div>
          <span className="num-tab rounded-full bg-background-50 px-3 py-1 text-[11px] tracking-[0.2em] text-accent-700 ring-1 ring-accent-200">
            TOP {seeds.length} SEEDS
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-[1.1fr_0.9fr]">
          {/* head seed feature */}
          <article className="relative overflow-hidden rounded-3xl bg-background-50 ring-1 ring-background-200">
            <div className="relative aspect-[16/9] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=vibrant%20editorial%20photo%20of%20a%20glossy%20championship%20trophy%20standing%20on%20a%20podium%20decorated%20with%20fresh%20watermelon%20slices%20and%20confetti%2C%20warm%20cream%20studio%20background%2C%20coral%20and%20green%20accent%20lighting%2C%20celebratory%20winner%20mood%2C%20clean%20high%20contrast%20commercial%20photography&width=1200&height=675&seq=gua-headseed&orientation=landscape"
                alt="头号种子瓜王主题图：登上领奖台的金色奖杯，周围环绕新鲜西瓜与彩带"
                className="h-full w-full object-cover object-center"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/40 to-transparent p-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-trophy-fill" />
                  头号种子 · 断层票王
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-5 p-6 md:flex-row md:items-start md:justify-between">
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-2xl font-bold text-foreground-950">{top.name}</h3>
                  <span className={`rounded-full px-2 py-0.5 text-[11px] ${catTone(top.category)}`}>
                    {topCat.name}
                  </span>
                </div>
                <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">{top.insight}</p>
                <p className="mt-4 text-xs text-foreground-500">
                  评委点评：{top.note}——连续三轮反转，话题生命周期断层领先，被瓜友称为“今年续航最久的名场面”。
                </p>
              </div>
              <div className="shrink-0 rounded-2xl bg-accent-100 px-6 py-4 text-center">
                <p className="num-tab text-4xl text-accent-700">{top.heat}</p>
                <p className="mt-1 text-xs text-accent-900">热力值</p>
              </div>
            </div>
          </article>

          {/* rest seeds */}
          <div className="flex flex-col gap-4">
            {rest.map((s, i) => {
              const c = catOf(s.category);
              return (
                <article
                  key={s.name}
                  className="flex flex-1 items-start gap-4 rounded-3xl bg-background-50 p-5 ring-1 ring-background-200 transition-all hover:-translate-y-0.5 hover:ring-accent-300"
                >
                  <span className={`num-tab flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-lg ${medal(i + 1)}`}>
                    {i + 2}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-lg font-bold text-foreground-950">{s.name}</h3>
                      <span className={`rounded-full px-2 py-0.5 text-[11px] ${catTone(s.category)}`}>{c.name}</span>
                    </div>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{s.insight}</p>
                    <p className="num-tab mt-2 text-sm text-accent-700">热力 {s.heat}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}